import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Input,
  Form,
  Select,
  Row,
  Col,
  Spin,
  Tooltip,
  message
} from "antd";
import {
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import UserIcon from "../../../../assets/images/icons/userLogo.svg";
import { useLocation, useParams } from "react-router-dom";
import { useStore } from "../../../../store";
import { TAB_KEYS } from "../../../../config";
import { useTab } from "../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../utils";
import ReactPlayer from "react-player/youtube";
import { toast } from "react-toastify";
import { truncateFilename, sortDataByOrder } from "../../../../utils/helper"
import userServiceApi from "../../../../api/userServiceApi";
import { deleteRequest } from "../../../../api/http";
import SynthesiaVideo from "./SynthesiaVideo";
import reArrangeOrder from "../../../common/DragAndDropList/rearrangeHelper";
import {
  DragAndDropList,
  GifCreator,
  GifResultPreview,
  createEmptyGifState,
  hydrateGifCreatorState,
} from "../../../common";

const { TextArea } = Input;
const MAX_CHARACTERS = 700;

const withGifDefaults = (rows) => {
  if (!Array.isArray(rows)) return rows;
  return rows.map((row) => {
    if (row?.mediaLink?.mediaType === "GIF") {
      return {
        ...row,
        mediaLink: {
          ...row.mediaLink,
          gifCreator: hydrateGifCreatorState(row.mediaLink),
        },
      };
    }
    return row;
  });
};

export default function ServiceComponent({ dataLoader, form, getSingleTabData, loader: formDataLoader }) {
  const { state } = useLocation();
  const { micrositeId } = useParams();

  const tabKey = state;
  const { tabData } = useStore();
  const whichTab = TAB_KEYS.service;
  const tabConfigId = localStorage?.getItem("selectedTabId");
  const { deleteSingleItem, postLoader } = useTab();
  const { updateImage, updateFile } = useConnectsuForm();
  const [loader, setLoader] = useState(formDataLoader || true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();

  // 🔹 New states for controlling Add/Clear
 const [, setShowClear] = useState(false);
 const [, setClearEnabled] = useState(false);
  const [canAddNew, setCanAddNew] = useState(true);
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);

  useEffect(() => {
    localStorage.setItem("tab", "SERVICE");
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(updatedValues).length]);

  const renderMedia = (dataItem, rowIndex) => {
    const commonStyles = {
      display: "flex",
      justifyContent: "center",
    };

    if (
      dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <ReactPlayer
            controls={true}
            url={dataItem.mediaLink.url}
            width="100%"
            height="100%"
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <iframe
            title="Embedded video"
            src={dataItem.mediaLink.url}
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            width="100%"
            height="100%"
            style={{ backgroundColor: "black" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "IMAGE" &&
      dataItem.mediaLink.url
    ) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <img
            src={dataItem?.mediaLink?.url}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    } else if (
      dataItem?.mediaLink?.mediaType === "GIF"
    ) {
      const gifState = dataItem.mediaLink.gifCreator || {};
      const gifUrl = gifState.previewUrl || dataItem.mediaLink.url;
      return (
        <GifResultPreview
          url={gifUrl}
          fileName={gifState.fileName}
          loading={!!gifState.generating}
          showEdit={!!gifUrl && gifState.isEditing === false}
          onEdit={() => {
            const current = form.getFieldValue([
              whichTab,
              rowIndex,
              "mediaLink",
              "gifCreator",
            ]);
            form.setFieldValue(
              [whichTab, rowIndex, "mediaLink", "gifCreator"],
              { ...createEmptyGifState(), ...current, isEditing: true }
            );
          }}
        />
      );
    }

    else if (
      dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
      dataItem.mediaLink.url) {
      return (
        <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
          <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

        </div>
      )
    }


    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };
  const SelectChangeHandler = (e, i) => {
    form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
    if (e === "GIF") {
      form.setFieldValue(
        [whichTab, i, "mediaLink", "gifCreator"],
        createEmptyGifState()
      );
    } else {
      form.setFieldValue([whichTab, i, "mediaLink", "gifCreator"], undefined);
    }
  };

  const handleDeleteBrochure = async (id) => {
    try {
      const res = await deleteRequest(userServiceApi.deleteBrochure(id))
      if (res) {
        toast.success('Successfully Delete Brochure')
        getSingleTabData(tabKey, form)
      }
    } catch (error) {
      toast.error('Failed to Delete Brochure')
    }
  }

  // ✅ Reusable fresh row template
  const emptyRow = {
    id: undefined,
    title: "",
    description: "",
    mediaLink: { mediaType: undefined, url: "", gifCreator: undefined },
    urlLink: "",
    BrochureFile: null,
    brochureFileName: "",
    brochureFilePath: "",
    media: null,
  };

  // ✅ Handle Add More
  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];
    const newList = [emptyRow, ...currentList];

    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);
    setShowClear(true);
    setClearEnabled(true);

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // ✅ Handle Clear
  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const updatedList = currentList.map(item => (!item?.id ? { ...emptyRow } : item));

    form.setFieldsValue({ [whichTab]: updatedList });

    // refreshUnsavedState();

    setShowClear(false);
    setClearEnabled(false);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.service?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.service]);

  // ✅ Refresh Unsaved State
  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.mediaLink?.url?.trim() ||
        item?.media ||
        item?.BrochureFile ||
        item?.mediaLink?.gifCreator?.images?.length ||
        item?.mediaLink?.gifCreator?.generatedFile;

      return !item?.id && hasData;
    });

    setCanAddNew(!unsavedItem);
    setHasUnsavedItem(!!unsavedItem);
  };

  useEffect(() => {
    form.resetFields();
    if (tabData && tabData[whichTab] && tabData[whichTab].length > 0) {
      form.setFieldsValue({
        [whichTab]: withGifDefaults(sortDataByOrder(tabData[whichTab])),
      });
    }
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tabData[whichTab]]);


  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div className="newContantStyle">
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey === whichTab ? (
            <>
              <Col className="gutter-row tabContent" span={24}>
                <>
                  <Form.List
                    name={whichTab}
                  initialValue={
                    tabData &&
                      tabData[whichTab] &&
                      tabData[whichTab].length > 0
                      ? withGifDefaults(sortDataByOrder(tabData[whichTab]))
                      : [""]
                  }
                  >
                    {(fields, { add, remove, move }) => {
                      return (
                        <>
                        <Col
                          className="gutter-row tabContent"
                          xs={24}
                          sm={24}
                          md={14}
                          lg={14}
                          style={{ paddingRight: "25px" }}
                        >
                          <div className="inputBody">
                            <label></label>
                            <div style={{ textAlign: "right" }}>
                              {hasUnsavedItem && (
                                <Button
                                  className="cancelBtn"
                                  type="button"
                                  onClick={handleClear}
                                >
                                  Clear
                                </Button>
                              )}
                              <Button
                                className="greenBtn"
                                onClick={handleAddMore}
                              >
                                Add <PlusOutlined />
                              </Button>
                            </div>
                          </div>
                        </Col>

                        <Col
                          className="gutter-row tabContent"
                          xs={24}
                          sm={24}
                          md={10}
                          lg={10}
                        >
                        </Col>

                        <DragAndDropList
                          fields={fields}
                          move={move}
                          form={form}
                          fieldName={whichTab}
                          onReorder={(payload) => reArrangeOrder(userServiceApi.reArrangeCardsData({ micrositeId, tabConfigId }), payload)}
                          renderItem={({ key, name, ...restField }, i) => (
                            <div className="card-item">
                            <Col
                              className="gutter-row tabContent"
                              xs={24}
                              sm={24}
                              md={14}
                              lg={14}
                              style={{ paddingRight: "25px" }}
                            >
                              <div className="d-flex">
                                {/* <Form.Item
                                  {...restField}
                                  className="w-100"
                                  label="Service Name"
                                  name={[name, "title"]}
                                  labelCol={{ span: 5 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Service name is required",
                                    },
                                    {
                                      max: 40,
                                      message: "Title cannot exceed 40 characters",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Service Name"
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                  />
                                </Form.Item> */}

                                <Form.Item
                                  {...restField}
                                  className="w-100"
                                  label="Service Name"
                                  name={[name, "title"]}
                                  labelCol={{ span: 5 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Service name is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Service Name"
                                    maxLength={40}
                                    showCount={{
                                      formatter: ({ count }) => `${count}/40`,
                                    }}
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                    onKeyDown={(e) => {
                                      const currentValue =
                                        form.getFieldValue([whichTab, name, "title"]) || "";

                                      if (
                                        e.key.length === 1 && // normal characters only
                                        currentValue.length >= 40
                                      ) {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "title"],
                                            errors: ["Title cannot exceed 40 characters"],
                                          },
                                        ]);
                                      }
                                    }}
                                    onBlur={() => {
                                      form.setFields([
                                        {
                                          name: [whichTab, name, "title"],
                                          errors: [],
                                        },
                                      ]);
                                    }}
                                  />
                                </Form.Item>


                                <Form.Item>
                                  <div className="remove-btn">
                                    <DeleteOutlined
                                      title="Delete News"
                                      onClick={() => {
                                        const id = form.getFieldValue([
                                          whichTab,
                                          i,
                                          "id",
                                        ]);
                                        if (id) {
                                          deleteSingleItem(whichTab, id, form);
                                        } else {
                                          remove(name);
                                          setHasUnsavedItem(false);
                                          refreshUnsavedState();
                                        }
                                      }}
                                    />
                                  </div>
                                </Form.Item>
                              </div>

                              <Form.Item
                                label="Description"
                                {...restField}
                                name={[name, "description"]}
                                labelCol={{ span: 5 }}
                                rules={[
                                  {
                                    required: true,
                                    message: "Description is required",
                                  },
                                  {
                                    max: MAX_CHARACTERS - 1,
                                    message: `Description should be less than ${MAX_CHARACTERS} character`,
                                  },
                                ]}
                              >
                                <TextArea
                                  placeholder="Enter Description"
                                  rows={5}
                                  maxLength={MAX_CHARACTERS}
                                  showCount
                                  onChange={() => {
                                    setShowClear(true);
                                    setClearEnabled(true);
                                  }}
                                />
                              </Form.Item>

                              <div className="d-flex">
                                <Form.Item
                                  {...restField}
                                  className="w-100"
                                  name={[name, "mediaLink", "mediaType"]}
                                  label="Video or Image"
                                  labelCol={{ span: 5 }}
                                >
                                  <Select
                                    name={[name, "mediaLink", "mediaType"]}
                                    onChange={(e) => {
                                      SelectChangeHandler(e, i);
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                    placeholder="Select Option"
                                  >
                                    <Select.Option value="VIMEO_MEDIA">
                                      Add Vimeo Link
                                    </Select.Option>
                                    <Select.Option value="SOCIAL_MEDIA">
                                      Add Youtube Link
                                    </Select.Option>
                                    <Select.Option value="SYNTHESIA_MEDIA">
                                      Add Synthesia Link
                                    </Select.Option>
                                    <Select.Option value="IMAGE">
                                      Upload Image
                                    </Select.Option>
                                    <Select.Option value="GIF">
                                      Create GIF
                                    </Select.Option>
                                  </Select>
                                </Form.Item>
                                <Form.Item>
                                  <div className="remove-btn">
                                    <Tooltip title="Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio">
                                      <QuestionCircleOutlined />
                                    </Tooltip>
                                  </div>
                                </Form.Item>
                              </div>

                              {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                <Form.Item
                                  label="Youtube Link"
                                  {...restField}
                                  labelCol={{ span: 5 }}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                  />
                                </Form.Item>
                              ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                <Form.Item
                                  label="Vimeo Link"
                                  labelCol={{ span: 5 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}
                                >
                                  <Input
                                    onChange={() => {
                                      setShowClear(true);
                                      setClearEnabled(true);
                                    }}
                                  />
                                </Form.Item>
                              ) : findValue(i, "type") === "IMAGE" ? (
                                <Form.Item
                                  {...restField}
                                  label="Image"
                                  colon={false}
                                  name="media"
                                  className="experienceImg"
                                  labelCol={{ span: 5 }}
                                >
                                  {findValue(i, "blob") ? (
                                    <Avatar
                                      src={URL.createObjectURL(
                                        findValue(i, "blob")
                                      )}
                                    />
                                  ) : findValue(i, "url") ? (
                                    <Avatar src={findValue(i, "url")} />
                                  ) : (
                                    <Avatar src={UserIcon} />
                                  )}
                                  <label
                                    name="file"
                                    className="fileUploadBtn greenBtn"
                                  >
                                    Upload Image
                                    <input
                                      accept="image/png, image/gif, image/jpeg"
                                      type="file"
                                      onChange={(e) => {
                                        updateImage(e, i, form, whichTab);
                                        setShowClear(true);
                                        setClearEnabled(true);
                                      }}
                                    />
                                  </label>
                                  <Tooltip
                                    className="question"
                                    title={"Recommended image dimensions: 1280x720 pixels"}
                                  >
                                    <QuestionCircleOutlined />
                                  </Tooltip>
                                </Form.Item>
                              ) : findValue(i, "type") === "GIF" ? (
                                <Form.Item
                                  {...restField}
                                  label="Create GIF"
                                  colon={false}
                                  name={[name, "mediaLink", "gifCreator"]}
                                  className="gif-creator-field"
                                  labelCol={{ span: 5 }}
                                  initialValue={createEmptyGifState()}
                                >
                                  <GifCreator />
                                </Form.Item>
                              ) : findValue(i, "type") === "SYNTHESIA_MEDIA" ? (
                                <Form.Item
                                  label="Synthesia Link"
                                  labelCol={{ span: 5 }}
                                  {...restField}
                                  name={[name, "mediaLink", "url"]}

                                >
                                  <Input />
                                </Form.Item>
                              ) : null}

                              <Form.Item
                                label="External Link"
                                {...restField}
                                className="w-100"
                                name={[name, "urlLink"]}
                                labelCol={{ span: 5 }}
                              >
                                <Input
                                  placeholder="External Link"
                                  onChange={() => {
                                    setShowClear(true);
                                    setClearEnabled(true);
                                  }}
                                />
                              </Form.Item>

                              <div className="d-flex">
                                <Form.Item
                                  {...restField}
                                  label="Brochure"
                                  colon={false}
                                  name={[name, "BrochureFile"]}
                                  className="experienceImg w-100"
                                  labelCol={{ span: 5 }}
                                >
                                  {form.getFieldValue(tabKey)[i]
                                    ?.BrochureFile ? (
                                    truncateFilename(
                                      form.getFieldValue(tabKey)[i]
                                        ?.BrochureFile?.name
                                    )
                                  ) : form.getFieldValue(tabKey)[i]
                                    ?.brochureFileName ? (
                                    <>
                                      <a
                                        href={
                                          form.getFieldValue(tabKey)[i]
                                            .brochureFilePath || "#"
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <Button
                                          type="button"
                                          icon={<DownloadOutlined />}
                                        >
                                          {truncateFilename(
                                            form.getFieldValue(tabKey)[i]
                                              ?.brochureFileName
                                          )}
                                        </Button>
                                      </a>
                                      <Button
                                        icon={<DeleteOutlined />}
                                        onClick={() => {
                                          const brochureId =
                                            form.getFieldValue(tabKey)[i].id;
                                          if (brochureId)
                                            handleDeleteBrochure(brochureId);
                                        }}
                                      />
                                    </>
                                  ) : (
                                    "No file chosen"
                                  )}

                                  <label
                                    className="fileUploadBtn greenBtn"
                                    style={{ position: "relative" }}
                                  >
                                    {form.getFieldValue(tabKey)[i]
                                      ?.brochureFileName
                                      ? "Upload New Brochure"
                                      : "Upload Brochure"}

                                    <input
                                      type="file"
                                      accept="application/pdf"
                                      name={[name, "BrochureFile"]}
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (!file) return;

                                        // ✅ Validate MIME type and file extension
                                        const isPdf =
                                          file.type === "application/pdf" ||
                                          file.name
                                            .toLowerCase()
                                            .endsWith(".pdf");
                                        if (!isPdf) {
                                          message.error(
                                            "Only PDF files are allowed!"
                                          );
                                          e.target.value = ""; // reset input
                                          return;
                                        }

                                        // ✅ Validate file size (max 5MB)
                                        const maxSize = 5 * 1024 * 1024; // 5 MB
                                        if (file.size > maxSize) {
                                          message.error(
                                            "File size must be less than 5MB!"
                                          );
                                          e.target.value = ""; // reset input
                                          return;
                                        }

                                        // ✅ If valid, continue with existing logic
                                        updateFile(e, i, form, tabKey);
                                        setShowClear(true);
                                        setClearEnabled(true);
                                        setFormChanged(true);
                                      }}
                                    />

                                    <div
                                      className="remove-btn"
                                      style={{
                                        left: "initial",
                                        right: "-30px",
                                      }}
                                    >
                                      <Tooltip title="Only PDF files are allowed. Max size: 5MB.">
                                        <QuestionCircleOutlined />
                                      </Tooltip>
                                    </div>
                                  </label>
                                </Form.Item>
                              </div>

                              <Form.Item
                                className="w-100"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                {formChanged ? (
                                  <Button
                                    className="saveBtn greenBtn"
                                    onClick={() => {
                                      form.submit();
                                    }}
                                  >
                                    Save
                                  </Button>
                                ) : (
                                  <Button
                                    className="saveBtn greenBtn"
                                    style={{
                                      opacity: "0.5",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    Save
                                  </Button>
                                )}
                              </Form.Item>
                            </Col>

                            <Col
                              className="gutter-row tabContent"
                              xs={24}
                              sm={24}
                              md={10}
                              lg={10}
                            >
                              <Form.Item shouldUpdate noStyle>
                                {() => {
                                  const row = form.getFieldValue(whichTab)?.[i];
                                  if (!row) return null;
                                  return (
                                    <div>
                                      {renderMedia(row, i)}
                                    </div>
                                  );
                                }}
                              </Form.Item>
                            </Col>
                        </div>
                    )}
                  />
                      </>
                    );
                    }}
                  </Form.List>
                </>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
      </div>
    );
  }
}
